export const title = 'Conversão pós download';

Percentual de downloads que resultaram em uma compra no app até 24 horas após o download.
